export { default as useResolutionService } from './useResolutionService'
